import * as actionTypes from './actionTypes'

const localStorageAnswers = localStorage.getItem('testAnswers');
const answers = localStorageAnswers ? JSON.parse(localStorageAnswers) : [];

export const test = (state = {
  isFetching: true,
  isSubmiting: false,
  currentStepIndex: answers.length,
  endTime: null,
  stepsCount: 0,
  testSteps: [],
  answers: answers,
  error: null,
  score: 0,
  failedStep: undefined
}, action) => {
  switch (action.type) {
    case actionTypes.TEST_STEPS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actionTypes.TEST_STEPS_COMPLETE:
      return {
        ...state,
        ...action.testState,
        isFetching: false,
      };
    case actionTypes.TEST_STEPS_ERROR:
      return { ...state, isFetching: false, error: action.error };
    case actionTypes.SAVE_ANSWERS_COMPLETE:
      return {
        ...state,
        answers: action.testAnswers,
        currentStepIndex: action.currentStepIndex
      };
    case actionTypes.TEST_SUBMIT_REQUEST:
      return { ...state,
        isSubmiting: true
      };
    case actionTypes.TEST_START_COMPLETE:
      return {
        ...state,
        endTime: action.endTime
      };
    case actionTypes.TEST_SUBMIT_COMPLETE:
      return {
        ...state,
        score: action.score,
        failedStep: action.failedStep
      };
    case actionTypes.TEST_FAILED_COMPLETE:
      return {
        ...state,
        isFetching: false
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/store/test/reducers.js